import styled, { keyframes } from "styled-components";

const miniEnter = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 18px, 0) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
`;

export const StyledGameMiniPlayer = styled.aside`
  position: fixed;
  z-index: 190;
  right: 18px;
  bottom: 18px;
  display: flex;
  flex-direction: column;
  min-width: 300px;
  min-height: 210px;
  max-width: min(860px, calc(100vw - 28px));
  max-height: min(620px, calc(100dvh - 92px));
  overflow: hidden;
  resize: both;
  border-radius: 10px;
  border: 1px solid rgba(139, 177, 205, 0.2);
  background: #000;
  box-shadow: 0 22px 56px rgba(0, 0, 0, 0.42), 0 0 0 1px rgba(89, 244, 119, 0.08);
  animation: ${miniEnter} 220ms ease both;

  .mini-player-topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 44px;
    padding: 8px 8px 8px 12px;
    background: rgba(8, 28, 37, 0.96);
    border-bottom: 1px solid rgba(139, 177, 205, 0.14);
  }

  .mini-player-title {
    min-width: 0;
  }

  .mini-player-title span,
  .mini-player-title strong {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mini-player-title span {
    color: #91a8b8;
    font-size: 11px;
    font-weight: 700;
  }

  .mini-player-title strong {
    color: #ffffff;
    font-size: 13px;
    font-weight: 900;
  }

  .mini-player-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;
    flex: 0 0 auto;
    max-width: 58%;
    flex-wrap: wrap;
  }

  .mini-player-actions button {
    height: 28px;
    border: 0;
    border-radius: 7px;
    padding: 0 8px;
    color: #d9e7ef;
    background: rgba(42, 60, 73, 0.92);
    font-size: 11px;
    font-weight: 900;
    cursor: pointer;
    transition:
      transform 160ms ease,
      background 160ms ease,
      color 160ms ease;
  }

  .mini-player-actions button:hover,
  .mini-player-actions button:focus-visible {
    transform: translateY(-1px);
    color: #07131b;
    background: var(--crypto-accent);
  }

  .mini-player-actions button:last-child {
    width: 28px;
    padding: 0;
    color: #ffffff;
    background: rgba(216, 76, 95, 0.88);
    font-size: 18px;
    line-height: 1;
  }

  .mini-player-frame-wrap {
    position: relative;
    flex: 1 1 auto;
    min-height: 0;
    background: #000;
  }

  .mini-player-frame {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
    background: #000;
  }

  .mini-player-loading {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    color: #9fb2c1;
    background: #000;
    font-size: 12px;
    font-weight: 800;
    pointer-events: none;
    transition: opacity 180ms ease, visibility 180ms ease;
  }

  .mini-player-loading.is-hidden {
    opacity: 0;
    visibility: hidden;
  }

  @media (max-width: 575px) {
    right: 10px;
    bottom: calc(70px + env(safe-area-inset-bottom));
    width: calc(100vw - 20px) !important;
    height: 300px !important;
    min-width: 0;
    max-width: calc(100vw - 20px);
    resize: vertical;

    .mini-player-topbar {
      min-height: 54px;
    }

    .mini-player-actions {
      max-width: 66%;
    }
  }
`;
